import React from "react";

import { Card, Box, Typography, Theme } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { APP_BAR_HEIGHT } from "../../AppBar";
import { useSidebarContext } from "../Sidebar";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    height: `calc(100vh - ${APP_BAR_HEIGHT}px - 2px)`, // -2px for the weird gap between panel and appbar
    width: "390px",
    margin: `calc(${theme.spacing(12)} + 2px) 0 0`, // +2px for the weird gap between panel and appbar
    overflow: "hidden",
    zIndex: 999,
  },

  title: {
    textTransform: "capitalize",
  },

  link: {
    textDecoration: "none",
    color: "inherit",
  },

  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
}));

interface HoverBaseProps {
  /**
   * componentName should be match with openedComponent in useSideBarContext
   */
  componentName: string;
  /**
   * Link to a page when user click the expand text
   */
  expandLink: string;
}

const HoverBase: React.FC<HoverBaseProps> = ({
  componentName,
  expandLink,
  children,
}) => {
  const { state, dispatch } = useSidebarContext();
  const { classes } = useStyles();
  const open = Boolean(state.openedComponent === componentName.toLowerCase());
  return (
    <>
      {open && (
        <ClickAwayListener
          mouseEvent={state.keepOpen ? false : "onClick"}
          onClickAway={() => dispatch({ type: "close-component" })}
        >
          <Card
            onMouseEnter={() => dispatch({ type: "keep-open", payload: true })}
            onMouseLeave={() => dispatch({ type: "keep-open", payload: false })}
            className={classes.root}
          >
            <Box
              width="100%"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              padding={2}
            >
              <Typography
                variant="body1"
                fontWeight="bold"
                className={classes.title}
              >
                {componentName}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                onClick={() => dispatch({ type: "close-component" })}
              >
                <Link to={expandLink} className={classes.link}>
                  Expand
                </Link>
              </Typography>
            </Box>
            <main className={classes.main}>{children}</main>
          </Card>
        </ClickAwayListener>
      )}
    </>
  );
};
export default HoverBase;
